import axios from "axios";
import { config } from "../config";

const API_URL = config.API_URL;

const getTickers = (data) => {
    const payload = {
        userInfo: {
            ...data
        }
    }
    return axios.post(`${API_URL}gettickers`, payload);
}

const putTicker = (data) => {
    const payload = {
        userInfo: {
            ...data
        }
    }

    return axios.post(`${API_URL}putticker`, payload);
}

export default {
    getTickers,
    putTicker
}